<template>
    <div>
        <h1 style="font-size: 24px; color: black;">日报</h1>
        <el-card shadow="never">
            <el-row type="flex">
                <el-col>
                    <span> 产品分类</span>
                    <el-select v-model="dept" placeholder="请选择" @change="deptChange">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(value,key) in deptObj"
                                   :key="key"
                                   :label="value"
                                   :value="key"></el-option>
                    </el-select>
                </el-col>
                <el-col>
                    <span> 应用：</span>
                    <el-select v-model="queryData.packageName" placeholder="请选择" filterable collapse-tags multiple
                               @change="change">
                        <el-option v-for="app in appList"
                                   :key="app.packageName"
                                   :label="app.appName"
                                   :value="app.packageName"></el-option>
                    </el-select>
                </el-col>
                <el-col>
                    <span> 日期</span>
                    <el-date-picker
                        v-model="queryData.timeDate"
                        type="daterange"
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <el-button type="primary" @click="clear">清空</el-button>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button class="std" type="primary" @click="exportExcel">导出</el-button>

                </el-col>
                <el-upload :action="upload()" :headers="headers"
                           :on-success="handleZipSuccess"
                           :before-upload="beforeZipUpload"
                           :show-file-list="false"
                           v-loading.fullscreen.lock="loading"
                           ref="upload">
                    <el-button class="margin-left-10" type="success">导入</el-button>
                </el-upload>
                <el-button class="sub-sub" type="primary" @click="showDetails('新增渠道')">新增</el-button>
            </el-row>
        </el-card>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-date-picker
                v-model="dialogDate"
                type="daterange"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                @change="changeDialogDate"
            >
            </el-date-picker>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
            <div v-for="(date, index) in dateList" :key="date" class="mb-6 p-4 border border-gray-200 rounded-lg">
                <h3 class="font-medium mb-2">{{ date }}</h3>
                <el-form :model="formData[index]" label-width="80px">
                    <el-form-item label="桌面猫">
                        <el-input v-model="formData[index].item1"></el-input>
                    </el-form-item>
                    <el-form-item label="团团记账">
                        <el-input v-model="formData[index].item2"></el-input>
                    </el-form-item>
                    <el-form-item label="元元记账">
                        <el-input v-model="formData[index].item3"></el-input>
                    </el-form-item>
                    <el-form-item label="暖悦">
                        <el-input v-model="formData[index].item4"></el-input>
                    </el-form-item>
                </el-form>
            </div>

        </el-dialog>

        <h1>

            <h1 v-if="t===2">总数据</h1>
            <el-table height="calc(100vh - 260px)" v-if="t===2" :data="datas" border :fit="true" :key="21"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt" fixed="left" width="100"></el-table-column>
                <el-table-column label="星期" prop="week" fixed="left"></el-table-column>
                <el-table-column prop="name" label="整体数据" width="180">
                    <el-table-column label="总花费" prop="charge"></el-table-column>
                    <el-table-column label="当日roi" prop="roi208_daily"></el-table-column>
                    <el-table-column label="收入" prop="money_all"></el-table-column>
                    <el-table-column label="毛利" prop="ml"></el-table-column>
                    <el-table-column label="运营roi" prop="roi"></el-table-column>
                    <el-table-column label="总新增" prop="rn_all1"></el-table-column>
                    <el-table-column label="cpa" prop="cpa208"></el-table-column>
                    <el-table-column label="留存" prop="208_r1"></el-table-column>
                    <el-table-column label="ltv" prop="ltv208"></el-table-column>
                    <el-table-column label="ecpm" prop="ecpm208"></el-table-column>
                    <el-table-column label="ipu" prop="ipu208"></el-table-column>
                    <el-table-column label="关键行为成本" prop="charge_key_behavior"></el-table-column>
                    <el-table-column label="关键行为达成率" prop="key_behavior_rn1"></el-table-column>
                    <el-table-column label="活跃" prop="umactive"></el-table-column>
                    <el-table-column label="有价新增占比" prop="yjxz_rate"></el-table-column>
                    <el-table-column label="广告总收入" prop="ltv_la"></el-table-column>
                    <el-table-column label="总arpu" prop="arpu_day"></el-table-column>
                    <el-table-column label="总ecpm" prop="ecpm_la"></el-table-column>
                    <el-table-column label="总ipu" prop="ipu_la"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="激励视频" width="180">
                    <el-table-column label="激励视频总收入" prop="marge_rewarded_video_revenue"></el-table-column>
                    <el-table-column label="激励视频arpu" prop="arpu_jlsp"></el-table-column>
                    <el-table-column label="激励视频ecpm" prop="ecpm_jlsp"></el-table-column>
                    <el-table-column label="激励视频ipu" prop="ipu_jlsp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="开屏广告" width="180">
                    <el-table-column label="开屏广告总收入" prop="marge_splash_revenue"></el-table-column>
                    <el-table-column label="开屏广告arpu" prop="arpu_kp"></el-table-column>
                    <el-table-column label="开屏广告ecpm" prop="ecpm_kp"></el-table-column>
                    <el-table-column label="开屏广告ipu" prop="ipu_kp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="插屏广告" width="180">
                    <el-table-column label="插屏广告总收入" prop="marge_interstitial_revenue"></el-table-column>
                    <el-table-column label="插屏广告arpu" prop="arpu_cp"></el-table-column>
                    <el-table-column label="插屏广告ecpm" prop="ecpm_cp"></el-table-column>
                    <el-table-column label="插屏广告ipu" prop="ipu_cp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="信息流" width="180">
                    <el-table-column label="信息流总收入" prop="marge_flow_revenue"></el-table-column>
                    <el-table-column label="信息流arpu" prop="arpu_flow"></el-table-column>
                    <el-table-column label="信息流ecpm" prop="ecpm_flow"></el-table-column>
                    <el-table-column label="信息流ipu" prop="ipu_flow"></el-table-column>
                </el-table-column>
            </el-table>
            <h1 v-if="t===2">投放数据</h1>
            <el-table height="calc(100vh - 260px)" v-if="t===2" :data="datas" border :fit="true" :key="22"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt" fixed="left" width="100"></el-table-column>
                <el-table-column label="星期" prop="week" fixed="left"></el-table-column>
                <el-table-column prop="name" label="巨量" width="180">
                    <el-table-column label="总花费" prop="charge_jl"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_jl"></el-table-column>
                    <el-table-column label="总新增" prop="rn1_jl"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_jl"></el-table-column>
                    <el-table-column label="留存" prop="ml_r1_jl"></el-table-column>
                    <el-table-column label="ltv" prop="ltv_jl"></el-table-column>
                    <el-table-column label="ecpm" prop="ecpm_jl"></el-table-column>
                    <el-table-column label="ipu" prop="ipu_jl"></el-table-column>
                    <el-table-column label="关键行为成本" prop="charge_key_behavior_jl"></el-table-column>
                    <el-table-column label="关键行为达成率" prop="key_behavior_rn1_jl"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="磁力" width="180">
                    <el-table-column label="总花费" prop="charge_cl" key="3"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_cl" key="5"></el-table-column>
                    <el-table-column label="总新增" prop="rn1_cl" key="4"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_cl" key="6"></el-table-column>
                    <el-table-column label="留存" prop="ml_r1_cl" key="7"></el-table-column>
                    <el-table-column label="ltv" prop="ltv_cl" key="8"></el-table-column>
                    <el-table-column label="ecpm" prop="ecpm_cl" key="9"></el-table-column>
                    <el-table-column label="ipu" prop="ipu_cl" key="10"></el-table-column>
                    <el-table-column label="关键行为成本" prop="charge_key_behavior_cl" key="11"></el-table-column>
                    <el-table-column label="关键行为达成率" prop="key_behavior_rn1_cl" key="12"></el-table-column>
                </el-table-column>
            </el-table>

            <h1 v-if="t===3">总数据</h1>
            <el-table height="calc(100vh - 260px)" v-if="t===3" :data="datas" border :fit="true" :key="3"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt" fixed="left" width="100"></el-table-column>
                <el-table-column label="星期" prop="week" fixed="left"></el-table-column>
                <el-table-column prop="name" label="整体数据" width="180">
                    <el-table-column label="总花费" prop="charge"></el-table-column>
                    <el-table-column label="当日roi" prop="roi208"></el-table-column>
                    <el-table-column label="收入" prop="money_all"></el-table-column>
                    <el-table-column label="毛利" prop="ml"></el-table-column>
                    <el-table-column label="运营roi" prop="roi"></el-table-column>
                    <el-table-column label="总新增" prop="umnew"></el-table-column>
                    <el-table-column label="cpa" prop="cpa"></el-table-column>
                    <el-table-column label="留存" prop="ql_r1"></el-table-column>

                    <el-table-column label="ltv" prop="ltv_mt"></el-table-column>
                    <el-table-column label="ecpm" prop="ecpm_mt"></el-table-column>
                    <el-table-column label="ipu" prop="ipu_mt"></el-table-column>

                    <el-table-column label="关键行为成本" prop="charge_key_behavior"></el-table-column>
                    <el-table-column label="关键行为达成率" prop="key_behavior_rn1"></el-table-column>

                    <el-table-column label="活跃" prop="umactive"></el-table-column>
                    <el-table-column label="有价新增占比" prop="yjxz_mt_rate"></el-table-column>
                    <el-table-column label="广告总收入" prop="ltv_la"></el-table-column>
                    <el-table-column label="总arpu" prop="arpu_day"></el-table-column>
                    <el-table-column label="总ecpm" prop="ecpm_la"></el-table-column>
                    <el-table-column label="总ipu" prop="ipu_la"></el-table-column>
                </el-table-column>

                <el-table-column prop="name" label="激励视频" width="180">
                    <el-table-column label="激励视频总收入" prop="marge_rewarded_video_revenue"></el-table-column>
                    <el-table-column label="激励视频arpu" prop="arpu_jlsp"></el-table-column>
                    <el-table-column label="激励视频ecpm" prop="ecpm_jlsp"></el-table-column>
                    <el-table-column label="激励视频ipu" prop="ipu_jlsp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="开屏广告" width="180">
                    <el-table-column label="开屏广告总收入" prop="marge_splash_revenue"></el-table-column>
                    <el-table-column label="开屏广告arpu" prop="arpu_kp"></el-table-column>
                    <el-table-column label="开屏广告ecpm" prop="ecpm_kp"></el-table-column>
                    <el-table-column label="开屏广告ipu" prop="ipu_kp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="插屏广告" width="180">
                    <el-table-column label="插屏广告总收入" prop="marge_interstitial_revenue"></el-table-column>
                    <el-table-column label="插屏广告arpu" prop="arpu_cp"></el-table-column>
                    <el-table-column label="插屏广告ecpm" prop="ecpm_cp"></el-table-column>
                    <el-table-column label="插屏广告ipu" prop="ipu_cp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="信息流" width="180">
                    <el-table-column label="信息流总收入" prop="marge_flow_revenue"></el-table-column>
                    <el-table-column label="信息流arpu" prop="arpu_flow"></el-table-column>
                    <el-table-column label="信息流ecpm" prop="ecpm_flow"></el-table-column>
                    <el-table-column label="信息流ipu" prop="ipu_flow"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="抖音商城" width="180">
                    <el-table-column label="抖音商城总收入" prop="marge_dy_revenue"></el-table-column>
                    <el-table-column label="抖音商城arpu" prop="arpu_dy"></el-table-column>
                    <el-table-column label="抖音商城ecpm" prop="ecpm_dy"></el-table-column>
                    <el-table-column label="抖音商城ipu" prop="ipu_dy"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="aso" width="180">
                    <el-table-column label="新增" prop="rn1_aso"></el-table-column>
                    <el-table-column label="消耗" prop="charge_aso"></el-table-column>
                </el-table-column>
            </el-table>

            <h1 v-if="t===3">投放数据</h1>
            <div class="table-wrap">
                <el-table ref="tableT3" height="calc(100vh - 260px)" v-if="t===3" :data="datas" border :fit="true"
                          key="table-t3" @sort-change='sortChange'>
                    <el-table-column label="日期" prop="dt" fixed="left" width="100"></el-table-column>
                    <el-table-column label="星期" prop="week" fixed="left"></el-table-column>
                    <el-table-column prop="name" label="巨量" width="180">
                        <el-table-column label="总花费" prop="charge_jl"></el-table-column>
                        <el-table-column label="当日roi" prop="roi_jl"></el-table-column>
                        <el-table-column label="总新增" prop="rn1_jl"></el-table-column>
                        <el-table-column label="cpa" prop="cpa_jl"></el-table-column>
                        <el-table-column label="留存" prop="ml_r1_jl"></el-table-column>
                        <el-table-column label="ltv" prop="ltv_jl"></el-table-column>
                        <el-table-column label="ecpm" prop="ecpm_jl"></el-table-column>
                        <el-table-column label="ipu" prop="ipu_jl"></el-table-column>
                        <el-table-column label="关键行为成本" prop="charge_key_behavior_jl"></el-table-column>
                        <el-table-column label="关键行为达成率" prop="key_behavior_rn1_jl"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="name" label="磁力" width="180">
                        <el-table-column label="总花费" prop="charge_cl" key="3"></el-table-column>
                        <el-table-column label="当日roi" prop="roi_cl" key="5"></el-table-column>
                        <el-table-column label="总新增" prop="rn1_cl" key="4"></el-table-column>
                        <el-table-column label="cpa" prop="cpa_cl" key="6"></el-table-column>
                        <el-table-column label="留存" prop="ml_r1_cl" key="7"></el-table-column>
                        <el-table-column label="ltv" prop="ltv_cl" key="8"></el-table-column>
                        <el-table-column label="ecpm" prop="ecpm_cl" key="9"></el-table-column>
                        <el-table-column label="ipu" prop="ipu_cl" key="10"></el-table-column>
                        <el-table-column label="关键行为成本" prop="charge_key_behavior_cl" key="11"></el-table-column>
                        <el-table-column label="关键行为达成率" prop="key_behavior_rn1_cl" key="12"></el-table-column>
                    </el-table-column>

                    <el-table-column prop="name" label="广点通" width="180">
                        <el-table-column label="总花费" prop="charge_gdt" width="90"></el-table-column>
                        <el-table-column label="当日roi" prop="roi_gdt" width="90"></el-table-column>
                        <el-table-column label="总新增" prop="rn1_gdt" width="90"></el-table-column>
                        <el-table-column label="cpa" prop="cpa_gdt" width="90"></el-table-column>
                        <el-table-column label="留存" prop="ml_r1_gdt" width="90"></el-table-column>
                        <el-table-column label="ltv" prop="ltv_gdt" width="90"></el-table-column>
                        <el-table-column label="ecpm" prop="ecpm_gdt" width="90"></el-table-column>
                        <el-table-column label="ipu" prop="ipu_gdt" width="90"></el-table-column>
                        <el-table-column label="关键行为成本" prop="charge_key_behavior_gdt"
                                         width="110"></el-table-column>
                        <el-table-column label="关键行为达成率" prop="key_behavior_rn1_gdt"
                                         width="110"></el-table-column>
                    </el-table-column>
                </el-table>
            </div>

            <el-table height="calc(100vh - 260px)" v-if="t===4" :data="datas" border :fit="true" :key="4"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt" fixed="left" width="100"></el-table-column>
                <el-table-column label="星期" prop="week" fixed="left"></el-table-column>
                <el-table-column prop="name" label="整体数据" width="180">
                    <el-table-column label="总花费" prop="charge"></el-table-column>
                    <el-table-column label="总收益" prop="money_all"></el-table-column>
                    <el-table-column label="毛利" prop="ml"></el-table-column>
                    <el-table-column label="当日roi" prop="roi"></el-table-column>
                    <el-table-column label="活跃用户" prop="umactive"></el-table-column>
                    <el-table-column label="新增用户" prop="umnew"></el-table-column>
                    <el-table-column label="cpa" prop="cpa"></el-table-column>
                    <el-table-column label="平均留存" prop="ql_r1"></el-table-column>
                    <el-table-column label="买量留存" prop="ml_r1"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="内购数据" width="180">
                    <el-table-column label="总收入" prop="pay_sum_real"></el-table-column>
                    <el-table-column label="arpu" prop="arpu_pay"></el-table-column>
                    <el-table-column label="总销售额" prop="pay_sum"></el-table-column>
                    <el-table-column label="订单笔数" prop="pay_count"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="广告总数" width="180">
                    <el-table-column label="广告总收入" prop="ltv_la"></el-table-column>
                    <el-table-column label="广告总arpu" prop="arpu_day"></el-table-column>
                    <el-table-column label="总ecpm" prop="ecpm_la"></el-table-column>
                    <el-table-column label="总ipu" prop="ipu_la"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="asa总数据" width="180">
                    <el-table-column label="asa总消耗" prop="charge_apple"></el-table-column>
                    <el-table-column label="asa总新增" prop="rn1_apple"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_apple"></el-table-column>
                    <el-table-column label="次留" prop="ml_r1_apple"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="信息流总数据" width="180">
                    <el-table-column label="信息流总消耗" prop="charge_xxl"></el-table-column>
                    <el-table-column label="信息流总新增" prop="rn1_xxl"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_208"></el-table-column>
                    <el-table-column label="信息流总cpa" prop="cpa_xxl"></el-table-column>
                    <el-table-column label="信息流总次留" prop="ml_r1_xxl"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="巨量" width="180">
                    <el-table-column label="巨量总消耗" prop="charge_jl"></el-table-column>
                    <el-table-column label="巨量总新增" prop="rn1_jl"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_jl"></el-table-column>
                    <el-table-column label="巨量cpa" prop="cpa_jl"></el-table-column>
                    <el-table-column label="巨量次留" prop="ml_r1_jl"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="小红书" width="180">
                    <el-table-column label="小红书总消耗" prop="charge_xhs"></el-table-column>
                    <el-table-column label="小红书总新增" prop="rn1_xhs"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_xhs"></el-table-column>
                    <el-table-column label="小红书cpa" prop="cpa_xhs"></el-table-column>
                    <el-table-column label="小红书次留" prop="ml_r1_xhs"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="激励视频" width="180">
                    <el-table-column label="激励视频总收入" prop="marge_rewarded_video_revenue"></el-table-column>
                    <el-table-column label="激励视频arpu" prop="arpu_jlsp"></el-table-column>
                    <el-table-column label="激励视频ecpm" prop="ecpm_jlsp"></el-table-column>
                    <el-table-column label="激励视频ipu" prop="ipu_jlsp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="开屏广告" width="180">
                    <el-table-column label="开屏广告总收入" prop="marge_splash_revenue"></el-table-column>
                    <el-table-column label="开屏广告arpu" prop="arpu_kp"></el-table-column>
                    <el-table-column label="开屏广告ecpm" prop="ecpm_kp"></el-table-column>
                    <el-table-column label="开屏广告ipu" prop="ipu_kp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="插屏广告" width="180">
                    <el-table-column label="插屏广告总收入" prop="marge_interstitial_revenue"></el-table-column>
                    <el-table-column label="插屏广告arpu" prop="arpu_cp"></el-table-column>
                    <el-table-column label="插屏广告ecpm" prop="ecpm_cp"></el-table-column>
                    <el-table-column label="插屏广告ipu" prop="ipu_cp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="信息流" width="180">
                    <el-table-column label="信息流广告总收入" prop="marge_flow_revenue"></el-table-column>
                    <el-table-column label="信息流广告arpu" prop="arpu_flow"></el-table-column>
                    <el-table-column label="信息流广告ecpm" prop="ecpm_flow"></el-table-column>
                    <el-table-column label="信息流广告ipu" prop="ipu_flow"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="抖音商城" width="180">
                    <el-table-column label="抖音商城总收入" prop="marge_dy_revenue"></el-table-column>
                    <el-table-column label="抖音商城arpu" prop="arpu_dy"></el-table-column>
                    <el-table-column label="抖音商城ecpm" prop="ecpm_dy"></el-table-column>
                    <el-table-column label="抖音商城ipu" prop="ipu_dy"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="aso" width="180">
                    <el-table-column label="新增" prop="rn1_aso"></el-table-column>
                    <el-table-column label="消耗" prop="charge_aso"></el-table-column>
                </el-table-column>
            </el-table>

            <el-table height="calc(100vh - 260px)" v-if="t===5" :data="datas" border :fit="true" :key="5"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt" fixed="left" width="100"></el-table-column>
                <el-table-column label="星期" prop="week" fixed="left"></el-table-column>
                <el-table-column prop="name" label="整体数据" width="180">
                    <el-table-column label="总花费" prop="charge"></el-table-column>
                    <el-table-column label="总收益" prop="money_all"></el-table-column>
                    <el-table-column label="毛利" prop="ml"></el-table-column>
                    <el-table-column label="当日roi" prop="roi"></el-table-column>
                    <el-table-column label="活跃用户" prop="umactive"></el-table-column>
                    <el-table-column label="新增用户" prop="umnew"></el-table-column>
                    <el-table-column label="cpa" prop="cpa"></el-table-column>
                    <el-table-column label="平均留存" prop="ql_r1"></el-table-column>
                    <el-table-column label="买量留存" prop="ml_r1"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="内购数据" width="180">
                    <el-table-column label="总收入" prop="pay_sum_real"></el-table-column>
                    <el-table-column label="arpu" prop="arpu_pay"></el-table-column>
                    <el-table-column label="总销售额" prop="pay_sum"></el-table-column>
                    <el-table-column label="订单笔数" prop="pay_count"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="广告总数" width="180">
                    <el-table-column label="广告总收入" prop="ltv_la"></el-table-column>
                    <el-table-column label="广告总arpu" prop="arpu_day"></el-table-column>
                    <el-table-column label="总ecpm" prop="ecpm_la"></el-table-column>
                    <el-table-column label="总ipu" prop="ipu_la"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="华为应用商店数据" width="180">
                    <el-table-column label="消耗总金额" prop="charge_huawei"></el-table-column>
                    <el-table-column label="总新增" prop="rn1_huawei"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_huawei"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_huawei"></el-table-column>
                    <el-table-column label="新增留存" prop="ml_r1_huawei"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="vivo应用商店数据" width="180">
                    <el-table-column label="消耗总金额" prop="charge_vivo"></el-table-column>
                    <el-table-column label="总新增" prop="rn1_vivo"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_vivo"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_vivo"></el-table-column>
                    <el-table-column label="新增留存" prop="ml_r1_vivo"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="oppo应用商店数据" width="180">
                    <el-table-column label="消耗总金额" prop="charge_oppo"></el-table-column>
                    <el-table-column label="总新增" prop="rn1_oppo"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_oppo"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_oppo"></el-table-column>
                    <el-table-column label="新增留存" prop="ml_r1_oppo"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="小米应用商店数据" width="180">
                    <el-table-column label="消耗总金额" prop="charge_xiaomi"></el-table-column>
                    <el-table-column label="总新增" prop="rn1_xiaomi"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_xiaomi"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_xiaomi"></el-table-column>
                    <el-table-column label="新增留存" prop="ml_r1_xiaomi"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="荣耀应用商店数据" width="180">
                    <el-table-column label="消耗总金额" prop="charge_honor"></el-table-column>
                    <el-table-column label="总新增" prop="rn1_honor"></el-table-column>
                    <el-table-column label="cpa" prop="cpa_honor"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_honor"></el-table-column>
                    <el-table-column label="新增留存" prop="ml_r1_honor"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="信息流总数据" width="180">
                    <el-table-column label="信息流总消耗" prop="charge_xxl"></el-table-column>
                    <el-table-column label="信息流总新增" prop="rn1_xxl"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_208"></el-table-column>
                    <el-table-column label="信息流总cpa" prop="cpa_xxl"></el-table-column>
                    <el-table-column label="信息流总次留" prop="ml_r1_xxl"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="巨量" width="180">
                    <el-table-column label="巨量总消耗" prop="charge_jl"></el-table-column>
                    <el-table-column label="巨量总新增" prop="rn1_jl"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_jl"></el-table-column>
                    <el-table-column label="巨量cpa" prop="cpa_jl"></el-table-column>
                    <el-table-column label="巨量次留" prop="ml_r1_jl"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="小红书" width="180">
                    <el-table-column label="小红书总消耗" prop="charge_xhs"></el-table-column>
                    <el-table-column label="小红书总新增" prop="rn1_xhs"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_xhs"></el-table-column>
                    <el-table-column label="小红书cpa" prop="cpa_xhs"></el-table-column>
                    <el-table-column label="小红书次留" prop="ml_r1_xhs"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="信息流总数据" width="180">
                    <el-table-column label="信息流总消耗" prop="charge_xxl"></el-table-column>
                    <el-table-column label="信息流总新增" prop="rn1_xxl"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_208"></el-table-column>
                    <el-table-column label="信息流总cpa" prop="cpa_xxl"></el-table-column>
                    <el-table-column label="信息流总次留" prop="ml_r1_xxl"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="巨量" width="180">
                    <el-table-column label="巨量总消耗" prop="charge_jl"></el-table-column>
                    <el-table-column label="巨量总新增" prop="rn1_jl"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_jl"></el-table-column>
                    <el-table-column label="巨量cpa" prop="cpa_jl"></el-table-column>
                    <el-table-column label="巨量次留" prop="ml_r1_jl"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="小红书" width="180">
                    <el-table-column label="小红书总消耗" prop="charge_xhs"></el-table-column>
                    <el-table-column label="小红书总新增" prop="rn1_xhs"></el-table-column>
                    <el-table-column label="当日roi" prop="roi_xhs"></el-table-column>
                    <el-table-column label="小红书cpa" prop="cpa_xhs"></el-table-column>
                    <el-table-column label="小红书次留" prop="ml_r1_xhs"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="激励视频" width="180">
                    <el-table-column label="激励视频总收入" prop="marge_rewarded_video_revenue"></el-table-column>
                    <el-table-column label="激励视频arpu" prop="arpu_jlsp"></el-table-column>
                    <el-table-column label="激励视频ecpm" prop="ecpm_jlsp"></el-table-column>
                    <el-table-column label="激励视频ipu" prop="ipu_jlsp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="开屏广告" width="180">
                    <el-table-column label="开屏广告总收入" prop="marge_splash_revenue"></el-table-column>
                    <el-table-column label="开屏广告arpu" prop="arpu_kp"></el-table-column>
                    <el-table-column label="开屏广告ecpm" prop="ecpm_kp"></el-table-column>
                    <el-table-column label="开屏广告ipu" prop="ipu_kp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="插屏广告" width="180">
                    <el-table-column label="插屏广告总收入" prop="marge_interstitial_revenue"></el-table-column>
                    <el-table-column label="插屏广告arpu" prop="arpu_cp"></el-table-column>
                    <el-table-column label="插屏广告ecpm" prop="ecpm_cp"></el-table-column>
                    <el-table-column label="插屏广告ipu" prop="ipu_cp"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="信息流" width="180">
                    <el-table-column label="信息流广告总收入" prop="marge_flow_revenue"></el-table-column>
                    <el-table-column label="信息流广告arpu" prop="arpu_flow"></el-table-column>
                    <el-table-column label="信息流广告ecpm" prop="ecpm_flow"></el-table-column>
                    <el-table-column label="信息流广告ipu" prop="ipu_flow"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="抖音商城" width="180">
                    <el-table-column label="抖音商城总收入" prop="marge_dy_revenue"></el-table-column>
                    <el-table-column label="抖音商城arpu" prop="arpu_dy"></el-table-column>
                    <el-table-column label="抖音商城ecpm" prop="ecpm_dy"></el-table-column>
                    <el-table-column label="抖音商城ipu" prop="ipu_dy"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="aso" width="180">
                    <el-table-column label="新增" prop="rn1_aso"></el-table-column>
                    <el-table-column label="消耗" prop="charge_aso"></el-table-column>
                </el-table-column>
            </el-table>

        </h1>

    </div>
</template>

<script>
import {downloadData, reportDaily, uploadList} from "@/http/outApi";
import settingMix from "@/utils/mix/common-setting";
import utils from "@/utils";

export default {
    name: "ReportDaily",
    mixins: [settingMix],
    data() {
        return {
            appList: [],
            needGetApp: true,
            checkAll: false,
            headers: {},
            datas: [],
            needDept: true,
            deptObj: {},
            dept: null,
            loading: false,
            dialogTitle: '',
            dialogVisible: false,
            queryData: {
                timeDate: ['', '']
            },
            dialogDate: ['', ''],
            dialogDateStart: null,
            dialogDateEnd: null,
            messageDialog: {
                show: false,
                title: null,
                message: null
            },
            dateList: [],
            formData: [],
            t: 2
        }
    },
    methods: {
        showDetails(title) {
            this.dialogTitle = title;
            this.dialogVisible = true;
            this.dialogDate = [new Date(), new Date()];
            this.dateList = [];
            this.formData = [];
            this.changeDialogDate();
        },
        changeDialogDate() {
            // 处理日期选择
            const [startDate, endDate] = this.dialogDate;
            this.dialogDateStart = startDate === '' ? null : startDate;
            this.dialogDateEnd = endDate === '' ? null : endDate;
            const dates = [];
            const formData = [];
            const generateMockData = (dateStr) => ({
                date: dateStr,
                item1: '110',
                item2: '2140',
                item3: '1300',
                item4: '1000'
            });
            try {
                // 如果有有效的开始和结束日期
                if (this.dialogDateStart && this.dialogDateEnd) {
                    // 将日期字符串转换为日期对象
                    const start = new Date(this.dialogDateStart);
                    const end = new Date(this.dialogDateEnd);
                    // 确保开始日期不晚于结束日期
                    if (start > end) {
                        throw new Error('开始日期不能晚于结束日期');
                    }
                    // 循环生成日期范围内的每一天
                    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                        const formattedDate = this.formatDate(new Date(d));
                        dates.push(formattedDate);
                        formData.push(generateMockData(formattedDate));
                    }
                } else {
                    // 如果没有选择日期范围，默认生成过去9天的数据
                    const date = new Date();
                    date.setDate(date.getDate());
                    const formattedDate = this.formatDate(date);
                    dates.push(formattedDate);
                    formData.push(generateMockData(formattedDate));
                }
            } catch (error) {
                console.error('日期生成过程中出错:', error);
                // 可以添加错误提示逻辑
            }
            this.dateList = dates;
            this.formData = formData;
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        confirmForm() {
            const result = [];
            this.formData.forEach(item => {
                result.push({
                    date: item.date,
                    packageName: 'com.gameley.desktopcat',
                    value: item.item1
                });
                result.push({
                    date: item.date,
                    packageName: 'com.gameley.iBookkeep',
                    value: item.item2
                });
                result.push({
                    date: item.date,
                    packageName: 'com.gameley.aibookkeep',
                    value: item.item3
                });
                result.push({
                    date: item.date,
                    packageName: 'com.gameley.aifemhealth',
                    value: item.item4
                });
            });
            uploadList(result).then(resp => {
                if (resp.data.status === 0) {
                    this.search();
                    this.dialogVisible = false;
                }
            });
        },
        change() {
            for (var x in this.appList) {
                var app = this.appList[x];
                if (app.packageName === this.queryData.packageName[0]) {
                    // 2 208
                    // 3 宠物、小游戏、新项目
                    // 4 记账苹果 暖悦
                    // 5 记账安卓 暖悦
                    var systemVersion = app.systemVersion;
                    var dept = app.dept;
                    if (dept === 3 || dept === 4 || dept === 6) {
                        this.t = 3;
                    } else if (dept === 2 || dept === 5) {
                        if (systemVersion === 'ios') {
                            this.t = 4;
                        }
                        if (systemVersion === 'android' || systemVersion === 'harmony') {
                            this.t = 5;
                        }
                    } else {
                        this.t = 2;
                    }
                    this.search();
                    return;
                }
            }
        },
        search() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
            this.queryData.excel = false;
            this.queryData.level = "day";
            reportDaily(this.queryData).then(resp => {
                this.datas = resp.data.info.content;
                this.$nextTick(() => {
                    // 延时等待三组表头、滚动条完全渲染
                    setTimeout(() => {
                        // 模拟窗口缩放，清空表格内部错乱缓存
                        window.dispatchEvent(new Event('resize'));
                    }, 120);
                })
            })
        },
        exportExcel() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
            this.queryData.excel = false;
            this.queryData.level = "day";
            let fileName = new Date().toLocaleString() + '应用回收日报.xlsx';
            downloadData(
                '/middle/exportApp',
                this.queryData,
                fileName
            )
        },
        sortChange(order) {
            this.queryData.order = order.order;
            this.queryData.prop = order.prop;
            this.search();
        },
        deptChange() {
            var list = [];
            for (var x in this.appList) {
                if (this.appList[x].dept + "" === this.dept + "" || this.dept === '') {
                    list.push(this.appList[x].packageName)
                }
            }
            this.queryData.packageName = list;
            this.change();
        },
        clear() {
            this.dept = null;
            this.queryData.packageName = [];
        },
        upload() {
            return this.VUE_APP_OUT_URL + '/middle/upload/excel';
        },
        handleZipSuccess(data) {
            this.loading = false;
            let title;
            if (data.status === 0) {
                title = "温馨提示";
            } else {
                title = "错误提示";
            }
            this.messageDialogFun(true, title, data.msg);
            this.search();
        },
        beforeZipUpload(data) {
            const type = data.name.substring(data.name.lastIndexOf('.')) === '.csv';
            const size = data.size < 1024 * 1024 * 100;
            if (!type) {
                this.$message.error('上传csv格式!');
            }
            if (!size) {
                this.$message.error('上传csv大小不能超过100m!');
            }
            let b = type && size;
            if (b) {
                this.loading = true;
                this.messageDialogFun(true, '温馨提示', '上传中，请稍候');
            }
            return type && size;
        },
        messageDialogFun(show, title, message) {
            this.messageDialog.show = show;
            this.messageDialog.title = title;
            this.messageDialog.message = message;
        },
    },
    created() {
        this.headers = {Authorization: this.$store.state.user.token};
        this.queryData.timeDate = [utils.TodayUtil.getWeekAgo1(), utils.TodayUtil.getYesterday()];
    },
    mounted() {
        this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        this.VUE_APP_OUT_URL = process.env.VUE_APP_OUT_URL;
    }
}
</script>

<style scoped>
.table-wrap {
    scrollbar-gutter: stable both-edges;
}

/deep/ .el-table th,
/deep/ .el-table td {
    box-sizing: border-box;
}
</style>
